import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from 'app/core/services/permission.service';
import { ADMIN_PANEL_DEFAULT_ROUTE_ORDER } from 'app/core/auth/admin-panel-permissions';

/**
 * Redireciona /admin para a primeira tela ADMIN_* permitida ao usuário.
 */
export const AdminDefaultRedirectGuard: CanActivateFn = () => {
    const router = inject(Router);
    const permissionService = inject(PermissionService);

    for (const item of ADMIN_PANEL_DEFAULT_ROUTE_ORDER) {
        if (permissionService.hasPermission(item.code)) {
            return router.parseUrl(item.link);
        }
    }

    return router.parseUrl('/home');
};
